import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { ERROR_CLEARALL } from "../Store/Types/AuthTypes";
import { userLogin } from "../Store/Actions/AuthAction";

const LoginInApp = ({ params }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { authenticate, errorMessageAuth } = useSelector((state) => state.auth);

	useEffect(() => {
		if (!authenticate && !localStorage.getItem("token")) {
			dispatch(userLogin(params.user, params.token, true));
		} else if (authenticate && params.token !== localStorage.getItem("token")) {
			navigate("/error/", { state: { app: true, token: params.token } });
		}
		else {
			navigate("/");
		}
	});
	useEffect(() => {
		if (errorMessageAuth) {
			dispatch({ type: ERROR_CLEARALL });
			navigate("/error", { state: { app: true, token: params.token } });
		}
	}, [errorMessageAuth]);
};

export default LoginInApp;
